import { render, staticRenderFns } from "./ManageStartups.vue?vue&type=template&id=30286918&"
import script from "./ManageStartups.vue?vue&type=script&lang=js&"
export * from "./ManageStartups.vue?vue&type=script&lang=js&"
import style0 from "./ManageStartups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports